import { CustomButtonProps } from '@/components/Button/Button';

export const buttonLogInProps: CustomButtonProps = {
  variant: 'secondary',
  w: 'full',
  fontWeight: 'normal',
};
